var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loading-box"},[_c('div',{staticClass:"loading-mask",class:_vm.show?'hyShow':''}),_vm._v(" "),_c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"animate"}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.txt))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68274d93","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/my_plugin/loading/Loading.vue
// module id = null
// module chunks = 